export default "__VITE_ASSET__BYOgFeVF__"